<template>
  <div :class="custom_class">
    <v-btn
      icon
      @click.stop="open_dialog"
      :small="small_button"
    >
    <!--
    
    -->
      <v-icon>
        {{ custom_icon || "mdi-close" }}
      </v-icon>
    </v-btn>
    <!-- DIALOG -->
    <v-dialog
      v-model="dialog"
      width="600px"
    >
      <v-card class="elevated-1">
        <!--
        text-h5 grey lighten-2 
        -->
        <v-card-title class="fc-centro-name-modal">
          {{ title || $vuetify.lang.translator('delete')  }}
        </v-card-title>

        <div class="ma-2">
          <slot name="content">
            <v-card-text class="pt-4">
              {{ text || "" }}
            </v-card-text>

          </slot>
        </div>
        
        <div class="modal-card-close" @click="close_dialog">
          <v-icon>mdi-close</v-icon>
        </div>
        <v-divider></v-divider>

        <div style="display: flex; flex-direction: row; justify-content: space-between; padding: 8px">
          <v-btn color="primary" text @click="close_dialog">
            {{ $vuetify.lang.translator('dialog.cancel') }}
          </v-btn>
          <v-btn color="primary" @click="submit">
            {{ $vuetify.lang.translator('dialog.confirm') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss">
  @import '@/sass/modalform.scss';
</style>

<script>
  export default {
    name: "DeleteButton",

    components: {
      
    },

    props: {
      custom_icon: {type: String, default: "mdi-trash-can-outline"},
      title: {type: String, default: "Delete"},
      text: {type: String, default: ""},
      custom_class: {type: String, default: ""},
      small_button: Boolean,
    },

    data: () => ({
      dialog: false,
    }),

    computed: {

    },

    methods: {
      open_dialog(){
        this.dialog = true;
      },

      close_dialog() {
        this.dialog = false;
      },

      submit() {
        this.$emit('submit');
        this.close_dialog();
      },
    },
  }
</script>
